import { StoreWaitingTime } from 'controlled-components';
import { CompleteStoreFragment } from 'drycut-graphql';
import { Para, Stack } from 'ui-components';
import StylistList from '../../BookingStepper/Steps/StylistList';

type Props = {
  store: CompleteStoreFragment;
};

export default function WaitingTimeDetails({ store }: Props): React.ReactElement {
  return (
    <Stack gap={2}>
      <Stack gap={1}>
        {store.openNow ? (
          <Para size="sm" pretty>
            Der nächste verfügbare Cut in
          </Para>
        ) : (
          <Para size="sm">Nächster freier Termin:</Para>
        )}
        <StoreWaitingTime store={store} approximate showZero steps />
      </Stack>

      {store.openNow && <StylistList stylists={store.checkedInStylists} size="sm" />}
    </Stack>
  );
}
